/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type VehicleType,
    VehicleTypeFromJSON,
    VehicleTypeToJSON,
} from '../models/VehicleType';
import {
    type VehicleTypeCreate,
    VehicleTypeCreateFromJSON,
    VehicleTypeCreateToJSON,
} from '../models/VehicleTypeCreate';
import {
    type VehicleTypeSortKey,
    VehicleTypeSortKeyFromJSON,
    VehicleTypeSortKeyToJSON,
} from '../models/VehicleTypeSortKey';
import {
    type VehicleTypeUpdate,
    VehicleTypeUpdateFromJSON,
    VehicleTypeUpdateToJSON,
} from '../models/VehicleTypeUpdate';

export interface VehicleTypesCreateVehicleTypeRequest {
    vehicleTypeCreate: VehicleTypeCreate;
}

export interface VehicleTypesDeleteVehicleTypeRequest {
    id: string;
}

export interface VehicleTypesListVehicleTypesRequest {
    pageSize: number;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleTypeSortKey;
}

export interface VehicleTypesListVehicleTypesMetadataRequest {
    pageSize: number;
}

export interface VehicleTypesReadVehicleTypeRequest {
    id: string;
}

export interface VehicleTypesUpdateVehicleTypeRequest {
    id: string;
    vehicleTypeUpdate: VehicleTypeUpdate;
}

export interface VehicleTypesValidateCreateVehicleTypeRequest {
    vehicleTypeCreate: VehicleTypeCreate;
}

export interface VehicleTypesValidateUpdateVehicleTypeRequest {
    id: string;
    vehicleTypeUpdate: VehicleTypeUpdate;
}

/**
 * VehicleTypesApi - interface
 * 
 * @export
 * @interface VehicleTypesApiInterface
 */
export interface VehicleTypesApiInterface {
    /**
     * Creates request options for vehicleTypesCreateVehicleType without sending the request
     * @param {VehicleTypeCreate} vehicleTypeCreate 
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesCreateVehicleTypeRequestOpts(requestParameters: VehicleTypesCreateVehicleTypeRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new vehicle type.
     * @summary Create a vehicle type
     * @param {VehicleTypeCreate} vehicleTypeCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesCreateVehicleTypeRaw(requestParameters: VehicleTypesCreateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleType>>;

    /**
     * Create a new vehicle type.
     * Create a vehicle type
     */
    vehicleTypesCreateVehicleType(requestParameters: VehicleTypesCreateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleType>;

    /**
     * Creates request options for vehicleTypesDeleteVehicleType without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesDeleteVehicleTypeRequestOpts(requestParameters: VehicleTypesDeleteVehicleTypeRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the vehicle type with the given ID.
     * @summary Delete a vehicle type
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesDeleteVehicleTypeRaw(requestParameters: VehicleTypesDeleteVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the vehicle type with the given ID.
     * Delete a vehicle type
     */
    vehicleTypesDeleteVehicleType(requestParameters: VehicleTypesDeleteVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehicleTypesListVehicleTypes without sending the request
     * @param {number} pageSize 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleTypeSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesListVehicleTypesRequestOpts(requestParameters: VehicleTypesListVehicleTypesRequest): Promise<runtime.RequestOpts>;

    /**
     * List all vehicle types.
     * @summary List vehicle types
     * @param {number} pageSize 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleTypeSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesListVehicleTypesRaw(requestParameters: VehicleTypesListVehicleTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleType>>>;

    /**
     * List all vehicle types.
     * List vehicle types
     */
    vehicleTypesListVehicleTypes(requestParameters: VehicleTypesListVehicleTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleType>>;

    /**
     * Creates request options for vehicleTypesListVehicleTypesMetadata without sending the request
     * @param {number} pageSize 
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesListVehicleTypesMetadataRequestOpts(requestParameters: VehicleTypesListVehicleTypesMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch the total number of pages available.
     * @summary Vehicle type listing metadata
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesListVehicleTypesMetadataRaw(requestParameters: VehicleTypesListVehicleTypesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch the total number of pages available.
     * Vehicle type listing metadata
     */
    vehicleTypesListVehicleTypesMetadata(requestParameters: VehicleTypesListVehicleTypesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for vehicleTypesReadVehicleType without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesReadVehicleTypeRequestOpts(requestParameters: VehicleTypesReadVehicleTypeRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the vehicle type with the given ID.
     * @summary Get a single vehicle type
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesReadVehicleTypeRaw(requestParameters: VehicleTypesReadVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleType>>;

    /**
     * Returns the vehicle type with the given ID.
     * Get a single vehicle type
     */
    vehicleTypesReadVehicleType(requestParameters: VehicleTypesReadVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleType>;

    /**
     * Creates request options for vehicleTypesUpdateVehicleType without sending the request
     * @param {string} id 
     * @param {VehicleTypeUpdate} vehicleTypeUpdate 
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesUpdateVehicleTypeRequestOpts(requestParameters: VehicleTypesUpdateVehicleTypeRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the vehicle type with the given ID.
     * @summary Update a vehicle type
     * @param {string} id 
     * @param {VehicleTypeUpdate} vehicleTypeUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesUpdateVehicleTypeRaw(requestParameters: VehicleTypesUpdateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleType>>;

    /**
     * Update the vehicle type with the given ID.
     * Update a vehicle type
     */
    vehicleTypesUpdateVehicleType(requestParameters: VehicleTypesUpdateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleType>;

    /**
     * Creates request options for vehicleTypesValidateCreateVehicleType without sending the request
     * @param {VehicleTypeCreate} vehicleTypeCreate 
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesValidateCreateVehicleTypeRequestOpts(requestParameters: VehicleTypesValidateCreateVehicleTypeRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new vehicle type.
     * @summary Validate a vehicle type
     * @param {VehicleTypeCreate} vehicleTypeCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesValidateCreateVehicleTypeRaw(requestParameters: VehicleTypesValidateCreateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new vehicle type.
     * Validate a vehicle type
     */
    vehicleTypesValidateCreateVehicleType(requestParameters: VehicleTypesValidateCreateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehicleTypesValidateUpdateVehicleType without sending the request
     * @param {string} id 
     * @param {VehicleTypeUpdate} vehicleTypeUpdate 
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesValidateUpdateVehicleTypeRequestOpts(requestParameters: VehicleTypesValidateUpdateVehicleTypeRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a vehicle type update.
     * @summary Validate a vehicle type update
     * @param {string} id 
     * @param {VehicleTypeUpdate} vehicleTypeUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApiInterface
     */
    vehicleTypesValidateUpdateVehicleTypeRaw(requestParameters: VehicleTypesValidateUpdateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a vehicle type update.
     * Validate a vehicle type update
     */
    vehicleTypesValidateUpdateVehicleType(requestParameters: VehicleTypesValidateUpdateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class VehicleTypesApi extends runtime.BaseAPI implements VehicleTypesApiInterface {

    /**
     * Creates request options for vehicleTypesCreateVehicleType without sending the request
     */
    async vehicleTypesCreateVehicleTypeRequestOpts(requestParameters: VehicleTypesCreateVehicleTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleTypeCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleTypeCreate',
                'Required parameter "vehicleTypeCreate" was null or undefined when calling vehicleTypesCreateVehicleType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_types/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleTypeCreateToJSON(requestParameters['vehicleTypeCreate']),
        };
    }

    /**
     * Create a new vehicle type.
     * Create a vehicle type
     */
    async vehicleTypesCreateVehicleTypeRaw(requestParameters: VehicleTypesCreateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleType>> {
        const requestOptions = await this.vehicleTypesCreateVehicleTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleTypeFromJSON(jsonValue));
    }

    /**
     * Create a new vehicle type.
     * Create a vehicle type
     */
    async vehicleTypesCreateVehicleType(requestParameters: VehicleTypesCreateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleType> {
        const response = await this.vehicleTypesCreateVehicleTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleTypesDeleteVehicleType without sending the request
     */
    async vehicleTypesDeleteVehicleTypeRequestOpts(requestParameters: VehicleTypesDeleteVehicleTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vehicleTypesDeleteVehicleType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_types/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the vehicle type with the given ID.
     * Delete a vehicle type
     */
    async vehicleTypesDeleteVehicleTypeRaw(requestParameters: VehicleTypesDeleteVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleTypesDeleteVehicleTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the vehicle type with the given ID.
     * Delete a vehicle type
     */
    async vehicleTypesDeleteVehicleType(requestParameters: VehicleTypesDeleteVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleTypesDeleteVehicleTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehicleTypesListVehicleTypes without sending the request
     */
    async vehicleTypesListVehicleTypesRequestOpts(requestParameters: VehicleTypesListVehicleTypesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleTypesListVehicleTypes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_types/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all vehicle types.
     * List vehicle types
     */
    async vehicleTypesListVehicleTypesRaw(requestParameters: VehicleTypesListVehicleTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleType>>> {
        const requestOptions = await this.vehicleTypesListVehicleTypesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VehicleTypeFromJSON));
    }

    /**
     * List all vehicle types.
     * List vehicle types
     */
    async vehicleTypesListVehicleTypes(requestParameters: VehicleTypesListVehicleTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleType>> {
        const response = await this.vehicleTypesListVehicleTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleTypesListVehicleTypesMetadata without sending the request
     */
    async vehicleTypesListVehicleTypesMetadataRequestOpts(requestParameters: VehicleTypesListVehicleTypesMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleTypesListVehicleTypesMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_types/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch the total number of pages available.
     * Vehicle type listing metadata
     */
    async vehicleTypesListVehicleTypesMetadataRaw(requestParameters: VehicleTypesListVehicleTypesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.vehicleTypesListVehicleTypesMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch the total number of pages available.
     * Vehicle type listing metadata
     */
    async vehicleTypesListVehicleTypesMetadata(requestParameters: VehicleTypesListVehicleTypesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.vehicleTypesListVehicleTypesMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleTypesReadVehicleType without sending the request
     */
    async vehicleTypesReadVehicleTypeRequestOpts(requestParameters: VehicleTypesReadVehicleTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vehicleTypesReadVehicleType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_types/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the vehicle type with the given ID.
     * Get a single vehicle type
     */
    async vehicleTypesReadVehicleTypeRaw(requestParameters: VehicleTypesReadVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleType>> {
        const requestOptions = await this.vehicleTypesReadVehicleTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleTypeFromJSON(jsonValue));
    }

    /**
     * Returns the vehicle type with the given ID.
     * Get a single vehicle type
     */
    async vehicleTypesReadVehicleType(requestParameters: VehicleTypesReadVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleType> {
        const response = await this.vehicleTypesReadVehicleTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleTypesUpdateVehicleType without sending the request
     */
    async vehicleTypesUpdateVehicleTypeRequestOpts(requestParameters: VehicleTypesUpdateVehicleTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vehicleTypesUpdateVehicleType().'
            );
        }

        if (requestParameters['vehicleTypeUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleTypeUpdate',
                'Required parameter "vehicleTypeUpdate" was null or undefined when calling vehicleTypesUpdateVehicleType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_types/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleTypeUpdateToJSON(requestParameters['vehicleTypeUpdate']),
        };
    }

    /**
     * Update the vehicle type with the given ID.
     * Update a vehicle type
     */
    async vehicleTypesUpdateVehicleTypeRaw(requestParameters: VehicleTypesUpdateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleType>> {
        const requestOptions = await this.vehicleTypesUpdateVehicleTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleTypeFromJSON(jsonValue));
    }

    /**
     * Update the vehicle type with the given ID.
     * Update a vehicle type
     */
    async vehicleTypesUpdateVehicleType(requestParameters: VehicleTypesUpdateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleType> {
        const response = await this.vehicleTypesUpdateVehicleTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleTypesValidateCreateVehicleType without sending the request
     */
    async vehicleTypesValidateCreateVehicleTypeRequestOpts(requestParameters: VehicleTypesValidateCreateVehicleTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleTypeCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleTypeCreate',
                'Required parameter "vehicleTypeCreate" was null or undefined when calling vehicleTypesValidateCreateVehicleType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_types/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleTypeCreateToJSON(requestParameters['vehicleTypeCreate']),
        };
    }

    /**
     * Validate data for a new vehicle type.
     * Validate a vehicle type
     */
    async vehicleTypesValidateCreateVehicleTypeRaw(requestParameters: VehicleTypesValidateCreateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleTypesValidateCreateVehicleTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new vehicle type.
     * Validate a vehicle type
     */
    async vehicleTypesValidateCreateVehicleType(requestParameters: VehicleTypesValidateCreateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleTypesValidateCreateVehicleTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehicleTypesValidateUpdateVehicleType without sending the request
     */
    async vehicleTypesValidateUpdateVehicleTypeRequestOpts(requestParameters: VehicleTypesValidateUpdateVehicleTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vehicleTypesValidateUpdateVehicleType().'
            );
        }

        if (requestParameters['vehicleTypeUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleTypeUpdate',
                'Required parameter "vehicleTypeUpdate" was null or undefined when calling vehicleTypesValidateUpdateVehicleType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_types/{id}/validate`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleTypeUpdateToJSON(requestParameters['vehicleTypeUpdate']),
        };
    }

    /**
     * Validate data for a vehicle type update.
     * Validate a vehicle type update
     */
    async vehicleTypesValidateUpdateVehicleTypeRaw(requestParameters: VehicleTypesValidateUpdateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleTypesValidateUpdateVehicleTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a vehicle type update.
     * Validate a vehicle type update
     */
    async vehicleTypesValidateUpdateVehicleType(requestParameters: VehicleTypesValidateUpdateVehicleTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleTypesValidateUpdateVehicleTypeRaw(requestParameters, initOverrides);
    }

}
